var module = angular.module('bbl.module.dashboard', [
  'bbl.services',
  'bbl.module.dashboard.routing',
  'bbl.module.dashboard.controller',
  'bbl.module.dashboard.directives',
  'bbl.module.dashboard.filters',
  'bbl.dashboard.directive.callers-table',
  'bbl.dashboard.directive.rooms-accordion',
  'bbl.dashboard.directive.bridges-list-view',
  'bbl.directives.join-zoom',
  'bbl.directives.dashboard-audio-player',
]);

require('./dashboard.style.less');
require('./dashboard.routing');
require('./dashboard.controller');
require('./dashboard.directives');
require('./dashboard.filters');
require('./callers-table/callers-table.directive');
require('./rooms-accordion/rooms-accordion.directive');
require('./bridges-list-view/bridges-list-view.directive');
require('./join-zoom');
require('./dashboard-audio-player');

// TODO: convert addRecordController to angular module
require('common/modals/add-record-controller').inject(module);



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/dashboard/dashboard.module.js
 ** module id = 318
 ** module chunks = 0
 **/